import styled from 'styled-components';

export default styled.div`
  .submit-button {
    width: 100%;
  }
`;
